//inserito if per controllo su banca bib altrimenti questo js manda in errore i date picker sulle altre banche
if ($("html").attr("data-bank") == "BIB") {
    $(document).ready(function() {
        var divs = document.querySelectorAll(".com1Slider__itemDate time");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	divs = Array.prototype.slice.call(divs);
        }
        divs.forEach(function(entry) {
            var mese = entry.innerText;
            if (mese.indexOf("Јан") > -1) {
                newmese = mese.replace("Јан", "Jan");
                entry.innerText = newmese;
            } else if (mese.indexOf("Феб") > -1) {
                newmese = mese.replace("Феб", "Feb");
                entry.innerText = newmese;
            } else if (mese.indexOf("Мар") > -1) {
                newmese = mese.replace("Мар", "Mar ");
                entry.innerText = newmese;
            } else if (mese.indexOf("Апр") > -1) {
                newmese = mese.replace("Апр", "Apr");
                entry.innerText = newmese;
            } else if (mese.indexOf("Мај") > -1) {
                newmese = mese.replace("Мај", "Maj");
                entry.innerText = newmese;
            } else if (mese.indexOf("Јун") > -1) {
                newmese = mese.replace("Јун", "Jun");
                entry.innerText = newmese;
            } else if (mese.indexOf("Јул") > -1) {
                newmese = mese.replace("Јул", "Jul");
                entry.innerText = newmese;
            } else if (mese.indexOf("Авг") > -1) {
                newmese = mese.replace("Авг", "Avg");
                entry.innerText = newmese;
            } else if (mese.indexOf("Сеп") > -1) {
                newmese = mese.replace("Сеп", "Sep");
                entry.innerText = newmese;
            } else if (mese.indexOf("Okt") > -1) {
                newmese = mese.replace("Okt", "Okt");
                entry.innerText = newmese;
            } else if (mese.indexOf("Нов") > -1) {
                newmese = mese.replace("Нов", "Nov");
                entry.innerText = newmese;
            } else if (mese.indexOf("Дец") > -1) {
                newmese = mese.replace("Дец", "Dec");
                entry.innerText = newmese;
            }
        });
    });

    var interval;
    var count = 0;
    $(document).ready(function() {
        interval = setInterval(timer, 1000);
    });

    function tempo() {
        var mesiC = document.querySelectorAll(".form-control span");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	mesiC = Array.prototype.slice.call(mesiC);
        }
        if (mesiC.length != count) {
            mesiC.forEach(function(entry) {
                var meseC = entry.innerText;
                if (meseC.indexOf("јануар") > -1) {
                    newmeseL = meseC.replace("јануар", "Januar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("фебруар") > -1) {
                    newmeseL = meseC.replace("фебруар", "Februar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("март") > -1) {
                    newmeseL = meseC.replace("март", "Mart");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("април") > -1) {
                    newmeseL = meseC.replace("април", "April");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("мај") > -1) {
                    newmeseL = meseC.replace("мај", "Maj");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јун") > -1) {
                    newmeseL = meseC.replace("јун", "Jun");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јул") > -1) {
                    newmeseL = meseC.replace("јул", "Jul");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("август") > -1) {
                    newmeseL = meseC.replace("август", "Avgust");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("септембар") > -1) {
                    newmeseL = meseC.replace("септембар", "Septembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("октобар") > -1) {
                    newmeseL = meseC.replace("октобар", "Oktobar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("новембар") > -1) {
                    newmeseL = meseC.replace("новембар", "Novembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("децембар") > -1) {
                    newmeseL = meseC.replace("децембар", "Decembar");
                    entry.innerText = newmeseL;
                }
            });
            clearInterval(interval);
            count = mesiC.length;
            $(".com15__filterItem").on("click", function(event) {
                interval = setInterval(tempo, 1000);
            });
        }
    }

    function timer() {
        var mesiC = document.querySelectorAll(".form-control span");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	mesiC = Array.prototype.slice.call(mesiC);
        }
        if (mesiC.length > 0) {
            mesiC.forEach(function(entry) {
                var meseC = entry.innerText;
                if (meseC.indexOf("јануар") > -1) {
                    newmeseL = meseC.replace("јануар", "Januar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("фебруар") > -1) {
                    newmeseL = meseC.replace("фебруар", "Februar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("март") > -1) {
                    newmeseL = meseC.replace("март", "Mart");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("април") > -1) {
                    newmeseL = meseC.replace("април", "April");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("мај") > -1) {
                    newmeseL = meseC.replace("мај", "Maj");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јун") > -1) {
                    newmeseL = meseC.replace("јун", "Jun");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јул") > -1) {
                    newmeseL = meseC.replace("јул", "Jul");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("август") > -1) {
                    newmeseL = meseC.replace("август", "Avgust");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("септембар") > -1) {
                    newmeseL = meseC.replace("септембар", "Septembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("октобар") > -1) {
                    newmeseL = meseC.replace("октобар", "Oktobar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("новембар") > -1) {
                    newmeseL = meseC.replace("новембар", "Novembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("децембар") > -1) {
                    newmeseL = meseC.replace("децембар", "Decembar");
                    entry.innerText = newmeseL;
                }
            });
            clearInterval(interval);
            $(".com15__filterItem").on("click", function(event) {
                interval = setInterval(tempo, 1000);
            });
        }
    }

    // mesi archivio
    $(document).ready(function() {
        interval = setInterval(changeMonth, 100);
    });

    var changeMonth = function() {
        var divs = document.querySelectorAll(".datepicker-month");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	divs = Array.prototype.slice.call(divs);
        }
        if (divs.length > 0) {
            $(divs).each(function(i , v) {
				if($(v)[0] != undefined){						   
					for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
						var meseC = $(v)[0].childNodes[cou].textContent;
						if (meseC.indexOf("јануар") > -1) {
							newmeseL = meseC.replace("јануар", "Januar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("фебруар") > -1) {
							newmeseL = meseC.replace("фебруар", "Februar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("март") > -1) {
							newmeseL = meseC.replace("март", "Mart");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("април") > -1) {
							newmeseL = meseC.replace("април", "April");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("мај") > -1) {
							newmeseL = meseC.replace("мај", "Maj");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("јун") > -1) {
							newmeseL = meseC.replace("јун", "Jun");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("јул") > -1) {
							newmeseL = meseC.replace("јул", "Jul");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("август") > -1) {
							newmeseL = meseC.replace("август", "Avgust");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("септембар") > -1) {
							newmeseL = meseC.replace("септембар", "Septembar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("октобар") > -1) {
							newmeseL = meseC.replace("октобар", "Oktobar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("новембар") > -1) {
							newmeseL = meseC.replace("новембар", "Novembar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						} else if (meseC.indexOf("децембар") > -1) {
							newmeseL = meseC.replace("децембар", "Decembar");
							$(v)[0].childNodes[cou].textContent = newmeseL;
					  
						}
					}
				}
            });
        }
    }
    
 // mesi archivio
    $(document).ready(function() {
        interval = setTimeout(changeMonthOfMediaRelease, 1000);
    });

    function changeMonthOfMediaRelease() {
        var divs = document.querySelectorAll('.bib .aboutCom-pressAndNews select[name="filterByMonth"] option span');
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	divs = Array.prototype.slice.call(divs);
        }
        var lang = $('html')[0].getAttribute('lang');
        if (divs.length > 0) {
        	var count = 0;
            divs.forEach(function(entry) {
                var meseC = entry.innerText;
                if(lang == "sr"){
                	if (count == 0) {
                        newmeseL = "Januar";
                        entry.innerText = newmeseL;
                    } else if (count == 1) {
                        newmeseL = "Februar";
                        entry.innerText = newmeseL;
                    } else if (count == 2) {
                        newmeseL = "Mart";
                        entry.innerText = newmeseL;
                    } else if (count == 3) {
                        newmeseL = "April";
                        entry.innerText = newmeseL;
                    } else if (count == 4) {
                        newmeseL = "Maj";
                        entry.innerText = newmeseL;
                    } else if (count == 5) {
                        newmeseL = "Jun";
                        entry.innerText = newmeseL;
                    } else if (count == 6) {
                        newmeseL = "Jul";
                        entry.innerText = newmeseL;
                    } else if (count == 7) {
                        newmeseL = "Avgust";
                        entry.innerText = newmeseL;
                    } else if (count == 8) {
                        newmeseL = "Septembar";
                        entry.innerText = newmeseL;
                    } else if (count == 9) {
                        newmeseL = "Oktobar";
                        entry.innerText = newmeseL;
                    } else if (count == 10) {
                        newmeseL = "Novembar";
                        entry.innerText = newmeseL;
                    } else if (count == 11) {
                        newmeseL = "Decembar";
                        entry.innerText = newmeseL;
                    }
                } else if( lang == "en" ){
                	if (count == 0) {
                        newmeseL = "January";
                        entry.innerText = newmeseL;
                    } else if (count == 1) {
                        newmeseL = "February";
                        entry.innerText = newmeseL;
                    } else if (count == 2) {
                        newmeseL = "March";
                        entry.innerText = newmeseL;
                    } else if (count == 3) {
                        newmeseL = "April";
                        entry.innerText = newmeseL;
                    } else if (count == 4) {
                        newmeseL = "May";
                        entry.innerText = newmeseL;
                    } else if (count == 5) {
                        newmeseL = "June";
                        entry.innerText = newmeseL;
                    } else if (count == 6) {
                        newmeseL = "July";
                        entry.innerText = newmeseL;
                    } else if (count == 7) {
                        newmeseL = "August";
                        entry.innerText = newmeseL;
                    } else if (count == 8) {
                        newmeseL = "September";
                        entry.innerText = newmeseL;
                    } else if (count == 9) {
                        newmeseL = "October";
                        entry.innerText = newmeseL;
                    } else if (count == 10) {
                        newmeseL = "November";
                        entry.innerText = newmeseL;
                    } else if (count == 11) {
                        newmeseL = "December";
                        entry.innerText = newmeseL;
                    }
                }
                count = count+1;
            });
        }
    }

    var changeMesi = function() {
        var divs = document.querySelectorAll(".datepicker-month");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	divs = Array.prototype.slice.call(divs);
        }
        if (divs.length != count) {
            divs.forEach(function(entry) {
                var meseC = entry.innerText;
																		
																  
                if (meseC.indexOf("јануар") > -1) {
                    newmeseL = meseC.replace("јануар", "Januar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("фебруар") > -1) {
                    newmeseL = meseC.replace("фебруар", "Februar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("март") > -1) {
                    newmeseL = meseC.replace("март", "Mart");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("април") > -1) {
                    newmeseL = meseC.replace("април", "April");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("мај") > -1) {
                    newmeseL = meseC.replace("мај", "Maj");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јун") > -1) {
                    newmeseL = meseC.replace("јун", "Jun");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("јул") > -1) {
                    newmeseL = meseC.replace("јул", "Jul");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("август") > -1) {
                    newmeseL = meseC.replace("август", "Avgust");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("септембар") > -1) {
                    newmeseL = meseC.replace("септембар", "Septembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("октобар") > -1) {
                    newmeseL = meseC.replace("октобар", "Oktobar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("новембар") > -1) {
                    newmeseL = meseC.replace("новембар", "Novembar");
                    entry.innerText = newmeseL;
                } else if (meseC.indexOf("децембар") > -1) {
                    newmeseL = meseC.replace("децембар", "Decembar");
                    entry.innerText = newmeseL;
                }
			   
			  
				
            });
            clearInterval(interval);
            count = divs.length;
        }
    }
    $(".datepicker-month-prev.pull-left.enabled").on(
            "click",
            function(event) {
                interval = setInterval(changeMesi, 100);
            }
        );
    // mesi archivio cerchio

    $(document).ready(function() {
        interval = setInterval(mesiCicleFunc, 100);
    });

    var mesiCicleFunc = function() {
        var mesiCicle = document.querySelectorAll(".month.selectable");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 													 
        	mesiCicle = Array.prototype.slice.call(mesiCicle);
        }
        if (mesiCicle.length > 0) {
            $(mesiCicle).each(function(i, v) {
            	if($(v)[0] != undefined){	
	            	for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
		                var mese = $(v)[0].childNodes[cou].textContent;
		                if (mese.indexOf("јан") > -1) {
		                    newmese = mese.replace("јан", "Jan");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("феб") > -1) {
		                    newmese = mese.replace("феб", "Feb");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("мар") > -1) {
		                    newmese = mese.replace("мар", "Mar");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("апр") > -1) {
		                    newmese = mese.replace("апр", "Apr");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("мај") > -1) {
		                    newmese = mese.replace("мај", "Maj");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("јун") > -1) {
		                    newmese = mese.replace("јун", "Jun");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("јул") > -1) {
		                    newmese = mese.replace("јул", "Jul");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("авг") > -1) {
		                    newmese = mese.replace("авг", "Avg");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("сеп") > -1) {
		                    newmese = mese.replace("сеп", "Sep");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("окт") > -1) {
		                    newmese = mese.replace("окт", "Okt");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("нов") > -1) {
		                    newmese = mese.replace("нов", "Nov");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("дец") > -1) {
		                    newmese = mese.replace("дец", "Dec");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                }
	            	}
            	}            
			});

        }
    }
    
    clearInterval(interval);
    $(".datepicker-month").on("click", function(event) {
        interval = setInterval(mesiCicleFunc, 100);
    });
    
    $(document).ready(function() {
        interval = setInterval(mesiCicleUnselectFunc, 100);
    });
    
    var mesiCicleUnselectFunc = function() {
        var mesiCicleUnselect = document.querySelectorAll(".month.unselectable");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){

        	mesiCicleUnselect = Array.prototype.slice.call(mesiCicleUnselect);
        }
        if (mesiCicleUnselect.length > 0) {
            $(mesiCicleUnselect).each(function(i, v) {
            	if($(v)[0] != undefined){	
	            	for(var cou = 0; cou < $(v)[0].childNodes.length; cou ++){
		                var mese = $(v)[0].childNodes[cou].textContent;
		                if (mese.indexOf("јан") > -1) {
		                    newmese = mese.replace("јан", "Jan");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("феб") > -1) {
		                    newmese = mese.replace("феб", "Feb");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("мар") > -1) {
		                    newmese = mese.replace("мар", "Mar");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("апр") > -1) {
		                    newmese = mese.replace("апр", "Apr");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("мај") > -1) {
		                    newmese = mese.replace("мај", "Maj");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("јун") > -1) {
		                    newmese = mese.replace("јун", "Jun");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("јул") > -1) {
		                    newmese = mese.replace("јул", "Jul");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("авг") > -1) {
		                    newmese = mese.replace("авг", "Avg");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("сеп") > -1) {
		                    newmese = mese.replace("сеп", "Sep");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("окт") > -1) {
		                    newmese = mese.replace("окт", "Okt");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("нов") > -1) {
		                    newmese = mese.replace("нов", "Nov");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                } else if (mese.indexOf("дец") > -1) {
		                    newmese = mese.replace("дец", "Dec");
		                    $(v)[0].childNodes[cou].textContent = newmese;
		                }
	            	}
            	}
            });
        }
    }

    clearInterval(interval);
    $(".datepicker-month").on("click", function(event) {
        interval = setInterval(mesiCicleUnselectFunc, 100);
    });
    
    // giorni archivio
    $(document).ready(function() {
        interval = setInterval(Days, 1000);
    });

    function Days() {
        var days = document.querySelectorAll(".datepicker-weekdays th");
        if (window.navigator.userAgent.indexOf("MSIE ") != -1){
																 
															   
        	days = Array.prototype.slice.call(days);
        }
        if (days.length > 0) {
            days.forEach(function(entry) {
                var day = entry.innerText;
                if (day.indexOf("п") > -1) {
                    newDay = day.replace("п", "P");
                    entry.innerText = newDay;
                } else if (day.indexOf("у") > -1) {
                    newDay = day.replace("у", "U");
                    entry.innerText = newDay;
                } else if (day.indexOf("с") > -1) {
                    newDay = day.replace("с", "S");
                    entry.innerText = newDay;
                } else if (day.indexOf("ч") > -1) {
                    newDay = day.replace("ч", "Č");
                    entry.innerText = newDay;
                } else if (day.indexOf("п") > -1) {
                    newDay = day.replace("п", "P");
                    entry.innerText = newDay;
                } else if (day.indexOf("с") > -1) {
                    newDay = day.replace("с", "S");
                    entry.innerText = newDay;
                } else if (day.indexOf("н") > -1) {
                    newDay = day.replace("н", "N");
                    entry.innerText = newDay;
                }
            });
            clearInterval(interval);
            $(".datepicker-month").on("click", function(event) {
                interval = setInterval(Days, 1000);
            });
        }
    }
}